import convertToDMN from 'components/modules/dmn/src/utils/convertToDmn';
import apiEndpoint from 'core/common/apiEndPoints';
import constants from 'core/constants/Constants';
import openNotificationWithIcon from 'core/utils/notification';
import dayjs from 'dayjs';
import resetRuleFields from 'pages/rules/utils/resetRuleFields';

const saveRule = async (
  values,
  isValChanged,
  state,
  mutate,
  uniqueId,
  form,
  setRefetchRuleDetails,
  refetchRuleDetails,
  onFinish,
  t,
  rulePlanDataObj,
  setSaveLoading,
  onDone = () => {}
) => {
  setSaveLoading(true);

  const isClawbackDirect =
    values?.clawback_type === 'RECALCULATION' ||
    values?.clawback_type === 'FULL';

  const ruleStart = dayjs(values?.rule_start_date, 'YYYY-MM-DD HH:mm:ss');
  const selected = dayjs(state.selectedDate, 'YYYY-MM-DD HH:mm:ss');

  if (!isClawbackDirect) {
    if (ruleStart.isSame(selected, 'second')) {
      state.setValidationMsg(true);
      setSaveLoading(false);
      return;
    }
    if (selected.diff(ruleStart, 'second') <= 2) {
      state.setValidationMsg(true);
      setSaveLoading(false);
      return;
    }
    state.setValidationMsg(false);
  }

  const xmlString = isClawbackDirect
    ? ''
    : convertToDMN(state.dmnData, values?.rule_name);

  console.log(xmlString, 'xmlString');

  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
  const outputElements = xmlDoc.getElementsByTagName('output');
  const outputNamesArray = [];
  for (let i = 0; i < outputElements?.length; i += 1) {
    const value = outputElements[i].getAttribute('name');
    outputNamesArray.push(value);
  }
  const formattedOutputValues = outputNamesArray?.map((item, index) => ({
    output: item,
    value: null,
    isSelected: false,
    id: index,
  }));
  const ruleOutputConfig = formattedOutputValues;

  const blob = new Blob([xmlString], { type: 'text/plain' });
  const file = new File(
    [blob],
    `${values.rule_name?.replaceAll(' ', '_')}.dmn`,
    { type: 'text/plain' }
  );

  let fileType = 'dmn';
  if (isClawbackDirect || values?.enter_amount) fileType = 'none';

  const formData = new FormData();
  if (!isClawbackDirect) {
    formData.append('file', file);
  } else {
    const emptyBlob = new Blob([''], { type: 'text/plain' });
    const emptyFile = new File([emptyBlob], 'empty.dmn', {
      type: 'text/plain',
    });
    formData.append('file', emptyFile);
  }
  formData.append('file_type', fileType);
  formData.append('reporting_payout_variable_type', 'number');
  formData.append('rule_output_config', JSON.stringify(ruleOutputConfig));
  // formData.append('rule_visibility', state.userDetails?.user_employee_id || '');
  // formData.append('rule_type', 'COMMON');
  Object.entries(values).forEach(([key, val]) => {
    if (typeof val === 'object' && val !== null) {
      formData.append(key, JSON.stringify(val));
    } else {
      formData.append(key, val === undefined ? '' : String(val));
    }
  });
  if (isClawbackDirect) {
    formData.set('rule_file_type', 'none');
    formData.set('is_new_dmn_uploaded', 'false');
    formData.delete('rule_file_path');
  }

  const isLatest = (state.previousValues as any)?.is_latest;
  let newValue = values;
  console.log(values, 'values');
  if (isValChanged === 'true') {
    newValue = {
      ...values,
      create_new_version: isLatest
        ? state.selectedDateOption !== 'current'
        : false,
      previous_rule_end_date: dayjs(state.selectedDate)
        .subtract(1, 'second')
        .format(constants.yyyymmddhhmmss),
      new_rule_start_date: dayjs(state.selectedDate).format(
        constants.yyyymmddhhmmss
      ),
    };
    formData.set('create_new_version', newValue.create_new_version);
    if (newValue?.create_new_version !== false) {
      formData.set('previous_rule_end_date', newValue.previous_rule_end_date);
      formData.set('new_rule_start_date', newValue.new_rule_start_date);
    }
  }
  if (state.allowEdit) {
    await mutate(
      {
        resource: `${state.pageType === 'Show' && rulePlanDataObj?.view_unique_id ? apiEndpoint.rules : apiEndpoint.rulesDraft}`,
        values: formData,
        id: uniqueId,
        successNotification: false,
        errorNotification: false,
        invalidates: [],
      },
      {
        onSuccess: async (data) => {
          const message =
            data?.data?.message || t('notifications.createSuccess');
          openNotificationWithIcon(
            constants.success,
            t('notifications.mutationSuccess'),
            message
          );
          await setRefetchRuleDetails(!refetchRuleDetails);
          await resetRuleFields(form, state);
          setSaveLoading(false);
          onDone?.();
        },
        onError(error) {
          const message = error?.message || t('notifications.somethingError');
          openNotificationWithIcon(
            constants.error,
            t('notifications.mutationError'),
            message
          );
          state.setNewVersionModal(false);
          state.setSelectedDateOption('current');
          state.setSelectedDate(null);
          setSaveLoading(false);
        },
      }
    );
  } else {
    await onFinish(formData);
    setSaveLoading(false);
    onDone?.();
  }
};

export default saveRule;
